import React, {Component} from 'react';
import PropTypes from "prop-types";
import {FormFeedback, Input, ListGroup} from "reactstrap";
import InputGroup from "reactstrap/es/InputGroup";
import InputGroupAddon from "reactstrap/es/InputGroupAddon";
import InputGroupText from "reactstrap/es/InputGroupText";
import classnames from "classnames";
import {connect} from "react-redux";
import _ from "lodash";
import InputMask from "react-input-mask";
import Button from "../../../../../components/Button";
import api from "../../../../../api";
import {FormattedMessage} from "react-intl";
import CheckboxIcon from "../../Components/checkboxIcon";
import QuestionContainer from "../../Components/questionContainer";
import IconInput from "../../Components/iconInput";

class PresentationTypePhone extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      smsCode: '',
      smsCodeChecking: false,
      smsCodeWrong: false,
      smsSending: false,
      smsSent: false,
      phoneValidationSms: !props.question.phoneValidationSms,
      apiError: null,
      errorChecked: false,
      errorPhone: false,
      errorCode: false,
      phoneChanged: false
    };

    this.onChangeAccetp = this.onChangeAccetp.bind(this);
    this.handlerOnClickValidPhoneSms = this.handlerOnClickValidPhoneSms.bind(this);
    this.handlerOnClickCheckSmsCode = this.handlerOnClickCheckSmsCode.bind(this);
    this.canShowError = this.canShowError.bind(this);
  }

  canShowError(value) {
    const {questionResponse} = this.props;
    if (questionResponse && questionResponse.excluding) {
      return false;
    }

    return value;
  }

  handlerOnClickValidPhoneSms(){
    const {surveyResponse, question} = this.props;

    this.setState({
      smsSending: true,
    });

    api.surveyResponse.questionResponse.open.phone.sendSms(surveyResponse, question, this.props.value.slice(3))
    .then(data => {
      if (data && data.error) {
        this.setState({
          smsSent: false,
          smsSending: false,
          apiError: data.error
        })
      } else {
        this.setState({
          smsSent: true,
          smsSending: false,
          apiError: null
        });
      }
    }).catch(res => {
      this.setState({
        smsSent: false,
        smsSending: false,
        apiError: 'api.error'
      })
    });
  }

  handlerOnClickCheckSmsCode(){
    const {surveyResponse, question} = this.props;
    this.setState({
      smsCodeChecking: true,
      smsCodeWrong: false,
    });

    api.surveyResponse.questionResponse.open.phone.checkCodeSms(surveyResponse, question, this.props.value, this.state.smsCode)
    .then(res => {
      this.setState({
        phoneValidationSms: true,
        smsCodeChecking: false,
      });
    })
    .catch(res => {
      this.setState({
        smsCodeWrong: true,
        smsCodeChecking: false,
      });
    });
  }

  onChangeAccetp(){
    const {checked} = this.state;

    this.setState({
      checked: !checked,
    }, () => {
      this.props.onUpdated();
    });
  }

  validValueAsPhone(){
    const {value} = this.props;
    const polishPhoneNumberRegex = /^(?:(\+|00)48)?\s?(\d{3})[- ]?(\d{3})[- ]?(\d{3})$/;

    return polishPhoneNumberRegex.test(value);
  }

  validate(){
    const {checked, phoneValidationSms, smsCode, smsCodeWrong} = this.state;
    const {value, validationTexts, question} = this.props;

    let validate = {
      valid: true,
      errors: []
    };

    if(value.length > 0){
      if (!this.validValueAsPhone()){
        validate.errors.push(validationTexts.phone)
        this.setState({
          errorPhone: true
        })
      } else {
        this.setState({
          errorPhone: false
        })
      }

      if(!phoneValidationSms){
        validate.errors.push(validationTexts.phoneValidationSms)
        this.setState({
          errorCode: true
        })
      } else {
        this.setState({
          errorCode: false
        })
      }
    } else if(question.required) {
      this.setState({
        errorPhone: true
      })
    }

    if(!checked){
      validate.errors.push(validationTexts.phoneAccept)
      this.setState({
        errorChecked: true
      })
    } else {
      this.setState({
        errorChecked: false
      })
    }

    validate.valid = _.isEmpty(validate.errors);

    return validate;
  }

  render() {
    const {value, question, validate} = this.props;
    const {checked, errorChecked, errorPhone, errorCode, smsSent, smsCode, smsCodeChecking, phoneValidationSms, smsCodeWrong, phoneChanged} = this.state;

    const phoneValueValidated = this.validValueAsPhone();

    return <QuestionContainer answersColumns={1}
        component={
          <React.Fragment>
            <div>
              <IconInput
                  classes={"mb-3"}
                  icon={<i className="fas fa-phone" />}
                  onChange={this.props.onChange}
                  value={value ? value : "+48"}
                  isError={this.canShowError(errorPhone)}
                  disabled={!phoneValueValidated}
                  placeholder={'999-999-999'}
              />
              {question.phoneValidationSms && <button className={classnames({
                "w-100 text-left rounded-button mt-3 mb-3": true,
                "disabled": !phoneValueValidated || smsSent
              })}
                  disabled={!phoneValueValidated || smsSent}
                  onClick={this.handlerOnClickValidPhoneSms}>
                <i className="fas fa-paper-plane text-white ml-3 mr-3"/> Wyślij kod weryfikacyjny
              </button>}
              {smsSent && !phoneValidationSms && <div>
                <IconInput
                    classes={"mb-3 mt-3"}
                    icon={<i className="fas fa-phone" />}
                    onChange={e => this.setState({smsCode: e.target.value})}
                    value={smsCode}
                    isError={this.canShowError(errorCode)}
                    disabled={!smsCode || smsCodeWrong}
                    placeholder={'xxxxxx'}
                />
                <button className={classnames({
                  "w-100 text-left rounded-button mt-3 mb-3": true,
                  "disabled": !smsCode
                })}
                    disabled={!smsCode}
                    onClick={this.handlerOnClickCheckSmsCode}>
                  <i className="fas fa-paper-plane text-white ml-3 mr-3"/> Potwierdź
                </button>
                {this.canShowError(smsCodeWrong) && <FormFeedback className="d-block text-center color-default">Podany kod SMS jest nieprawidłowy</FormFeedback>}
              </div>}
              {smsSent && this.canShowError(phoneValidationSms) && <div className="color-default text-center mt-1 mb-1">
                Numer telefonu został poprawnie zweryfikowany
              </div>}
              <p className={classnames({
                'mt-2': true,
                'error': this.canShowError(errorChecked),
                'color-default': true
              })} onClick={this.onChangeAccetp}
              >
                <CheckboxIcon checked={checked} classes={"mr-3 align-self-center"}/>
                <small><FormattedMessage id="question.open.email.rodoText">{msg => msg}</FormattedMessage></small>
              </p>
            </div>
          </React.Fragment>
        }
    />
  }
}

PresentationTypePhone.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    phoneValidationSms: PropTypes.bool.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    surveyResponse: state.surveyResponse
  }
}

export default connect(mapStateToProps, null, null, {withRef: true, forwardRef: true})(PresentationTypePhone);